import request from '@/axios'

export function fetchTimeZoneList () {
  return request({
    url : '/users/get_timezone',
    method:'GET'
  })
}

//need to change
export function getUserList (customerId) {
  return request({
    url : `/users/get_customer_user/${customerId}`,
    method : 'GET'
  })
}

export function getCurrentList (queryParams) {
  return request({
    url : `/fetch-currency-list?page=${queryParams}`,
    method : 'GET'
  })
}

export function scheduleTimeApi (customerId, payload) {
  return request({
    url : `/operationalUser/edit/schedule_settings/${customerId}`,
    method : 'POST',
    data : payload
  })
}

export function fetchScheduleApi (customerId) {
  return request({
    url : `/operationalUser/list/schedule_settings/${customerId}`,
    method : 'GET'
  })
}

export function DeactiveScheduleApi (customerId, payload) {
  return request({
    url : `/operationalUser/delete/schedule_settings/${customerId}`,
    method : 'POST',
    data : payload
  })
}

export function checkBreakTime (customerId, user_id, payload) {
  return request({
    url : `/operationalUser/check/break/status/${customerId}/${user_id}`,
    method : 'POST',
    data : payload
  })
}